module.exports = __webpack_public_path__ + "img/triangle-topText_hover.71a06195.png";